import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";

const CATS = ["Accounts & Billing", "Construction Query", "Documentation", "Site Visit Request", "Snagging Observation", "General Enquiry"];
const PRIO = ["P1", "P2", "P3", "P4"];

export default function BuyerTicketNew() {
  const [form, setForm] = useState({ category: "Construction Query", priority: "P3", subject: "", description: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async () => {
    if (!form.subject.trim() || !form.description.trim()) { toast.error("Subject and description are required"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/tickets", form);
      toast.success("Query raised — we'll get back soon.");
      nav(`/buyer/tickets/${data.ticket_id}`);
    } catch { toast.error("Failed to submit"); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-5 max-w-xl">
      <Link to="/buyer/tickets" className="rc-btn rc-btn-sm rc-btn-ghost -ml-3"><ChevronLeft size={16}/> Back</Link>
      <div>
        <div className="rc-title-1">Raise a Query</div>
        <div className="rc-callout">Your RM and site engineer will be notified.</div>
      </div>

      <div className="rc-card rc-card-padded space-y-4">
        <div>
          <label className="rc-footnote mb-1 block">Category</label>
          <select className="rc-input" value={form.category} onChange={(e) => setForm({...form, category: e.target.value})} data-testid="ticket-category">
            {CATS.map(c => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="rc-footnote mb-1 block">Priority</label>
          <select className="rc-input" value={form.priority} onChange={(e) => setForm({...form, priority: e.target.value})} data-testid="ticket-priority">
            {PRIO.map(p => <option key={p} value={p}>{p} — {p==='P1'?'Critical':p==='P2'?'High':p==='P3'?'Medium':'Low'}</option>)}
          </select>
        </div>
        <div>
          <label className="rc-footnote mb-1 block">Subject</label>
          <input className="rc-input" value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} data-testid="ticket-subject"/>
        </div>
        <div>
          <label className="rc-footnote mb-1 block">Description</label>
          <textarea className="rc-input min-h-[120px] !py-3" value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} data-testid="ticket-description"/>
        </div>
        <button onClick={submit} disabled={busy} className="rc-btn rc-btn-primary w-full" data-testid="ticket-submit">Submit Query</button>
      </div>
    </div>
  );
}
